<template>
    <div component="VideoRecorderSubtitles" v-if="scriptText">
        <div ref="scroller" class="scroller">
            <div ref="subtitles" class="subtitles">
                {{ scriptText }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoRecorderSubtitles',
    props: ['scriptText', 'isScrolling'],

    data() {
        return {
            intervalId: null,
            scrollHeight: 0,
            scrollSpeed: 0.8,
        };
    },

    mounted() {
        this.scrollHeight = this.$refs.subtitles.clientHeight - this.$refs.scroller.clientHeight;
        // this.startScroll();
    },

    methods: {
        startScroll() {
            this.intervalId = setInterval(() => {
                if (!this.$refs.scroller) {
                    clearInterval(this.intervalId);
                    return;
                }
                if (this.$refs.scroller.scrollTop > this.scrollHeight) {
                    clearInterval(this.intervalId);
                }
                this.$refs.scroller.scrollTop += this.scrollSpeed;
            }, 50);
        },

        stopScroll() {
            clearInterval(this.intervalId);
            this.$refs.scroller.scrollTop = 0;
        },
    },

    computed: {},

    watch: {
        isScrolling(val) {
            if (val) {
                this.startScroll();
            } else {
                this.stopScroll();
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='VideoRecorderSubtitles'] {
    position: absolute;
    top: 50px;
    left: 50%;
    padding: 20px;
    height: 155px;
    margin: 0 auto;
    width: 80%;
    max-width: 400px;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    .radius;

    .scroller {
        width: 100%;
        height: 100%;
        overflow-y: auto;
    }

    .subtitles {
        line-height: 1.6;
        text-align: center;
        font-size: 18px;
    }
}
</style>
